import React from "react";
import {HashLink} from 'react-router-hash-link';
import Modal from "../../Modal";

const LichaamShakenBabySyndroom = () => (
    <Modal>
        <div>
            <section id={'shakenbabysyndroom'}>
                <h1>Het shakenbabysyndroom</h1>

                <p className={'text'}>
                    Een bijzondere en zeer ernstige vorm van lichamelijke kindermishandeling is het
                    shakenbabysyndroom, waarbij een ouder of verzorger een baby zo hard door elkaar
                    schudt dat het kind daar allerlei klachten aan overhoudt.
                </p>

                <p className={'text'}>
                    Het shakenbabysyndroom komt voornamelijk voor bij kinderen jonger dan 4 jaar. De
                    kans op letsel als gevolg van het schudden is het grootst bij baby&#39;s tot ongeveer 1
                    jaar. De meeste slachtoffers vallen in de leeftijdscategorie van drie tot acht maanden,
                    maar ook dreumesen en peuters kunnen verwondingen oplopen als ze te hard door
                    elkaar worden geschud. De normale omgang met een baby en spelletjes als hop-
                    paardje-hop kunnen dit syndroom niet veroorzaken
                </p>
            </section>
        </div>
    </Modal>
);


export default LichaamShakenBabySyndroom;
